import React, { useState } from "react";
import { Button, Card, Form, message } from "antd";
import DatepickerRanger from "../toolbox/DatepickerRanger";
import strings from "../../utils/Localization";
import BankaHesapSelectOption from "../toolbox/BankaHesapSelectOption";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import moment from "moment";
import { useForm } from "antd/lib/form/Form";
import useVarsayilanDeger from "../../hooks/useVarsayilanDeger";
import useApi from "../../hooks/useApi";

export default function BankaRaporForm() {
  const [form] = useForm();
  const [fetchLoading, setFetchLoading] = useState(false);
  const { bankaRaporForm } = strings.bankaRapor.components;
  const { getDefaultSetting } = useVarsayilanDeger();
  const api = useApi();

  const onFinish = async (values) => {
    try {
      const { tarih, bankaId, bankaHesapId, dovizId } = values;

      const baslangicTarihi = moment(tarih[0]).format("YYYY-MM-DD");
      const bitisTarihi = moment(tarih[1]).format("YYYY-MM-DD");

      const pdfWindow = window.open(`${document.location.origin}/#/RaporYukleniyor`);
      setFetchLoading(true);
      const response = await api.post(
        "/rapordosya/banka",
        {
          BaslangicTarih: `${baslangicTarihi} 00:00:00`,
          BitisTarih: `${bitisTarihi} 23:59:59`,
          BankaId: bankaId === undefined ? 0 : bankaId,
          BankaHesapId: bankaHesapId === undefined ? 0 : bankaHesapId,
          DovizId: dovizId === undefined ? 0 : dovizId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        pdfWindow.document.location.href = response.data.data;
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const onValuesChange = (changedValues) => {
    if (Object.keys(changedValues).find((x) => x === "dovizId") !== undefined) {
      form.setFieldsValue({ bankaHesapId: undefined });
    }
  };

  return (
    <Card>
      <Form
        layout="vertical"
        size="middle"
        onFinish={onFinish}
        form={form}
        initialValues={{
          tarih: [moment().add("months", -12), moment()],
          dovizId: getDefaultSetting("doviz"),
        }}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          name="tarih"
          label={bankaRaporForm.tarihSeciniz}
          rules={[{ required: true }]}
        >
          <DatepickerRanger />
        </Form.Item>
        <Form.Item name="dovizId" label={strings.dovizSelectOption.dovizBaslik}>
          <DovizSelectOption allowClear />
        </Form.Item>
        <Form.Item
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.dovizId !== currentValues.dovizId
          }
        >
          {({ getFieldValue }) => {
            const currentDovizId = getFieldValue("dovizId");

            return (
              <Form.Item
                name="bankaHesapId"
                label={bankaRaporForm.bankaHesapSeciniz}
              >
                <BankaHesapSelectOption
                  requestBody={{
                    Data: {
                      dovizId: currentDovizId,
                    },
                  }}
                  disabled={currentDovizId === undefined ? true : false}
                  placeholder={
                    currentDovizId === undefined
                      ? bankaRaporForm.tumBankaHesaplar
                      : undefined
                  }
                  allowClear
                />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ float: "right" }}
          size="large"
          loading={fetchLoading}
        >
          {bankaRaporForm.raporAlButon}
        </Button>
      </Form>
    </Card>
  );
}
